import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: {
      'cs-CZ': 'https://kontaktoxycz.zendesk.com/hc/cs-cz',
      'pl-PL': 'https://kontaktoxypl.zendesk.com/hc/pl',
    },
  },
];

export default redirects;
